import React from 'react';

import { useMediaQuery } from 'react-responsive';

import Jumbotron from 'components/modules/box/Jumbotron';
import Panel from 'components/modules/box/Panel';
import Paper from 'components/modules/box/Paper';
import Button from 'components/modules/button/Button';
import AccountRegistrationConfirmation from 'components/organisms/registration/AccountRegistrationConfirmation';
import SingleColumnTemplate from 'components/templates/SingleColumnTemplate';
import { pageTitles } from 'constants/pageTitles';
import { AccountRegistrationFormValues } from 'interfaces/registration';

interface Props {
  formValues: AccountRegistrationFormValues;
  onBack: () => void;
  onClickAccountRegistration: () => void;
}

const AccountRegistrationConfirmationPage: React.FC<Props> = ({
  formValues,
  onBack,
  onClickAccountRegistration,
}) => {
  const isPC = useMediaQuery({ query: '(min-width: 640px)' });
  const margin = isPC ? '56px 0' : '0';
  const contentMargin = isPC ? '24px 0' : '0';
  const justifyContent = isPC ? 'center' : 'flex-start';
  return (
    <SingleColumnTemplate>
      <div style={{ margin }}>
        <Jumbotron>
          <Paper>
            <Panel
              title={pageTitles.accountRegistrationConfirmation}
              $strongHeader
            >
              <div
                style={{
                  height: '42px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: justifyContent,
                  margin: contentMargin,
                }}
              >
                以下の内容でアカウントの仮登録を行います。詳細をご確認ください。
              </div>
              <AccountRegistrationConfirmation
                formValues={formValues}
                isPC={isPC}
                onClickAccountRegistration={onClickAccountRegistration}
              />
              <Button
                style={{ display: 'block', margin: '0 auto 16px auto' }}
                color="link"
                size={isPC ? 'l' : 'm'}
                onClick={onBack}
              >
                &lt; 戻る
              </Button>
            </Panel>
          </Paper>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default AccountRegistrationConfirmationPage;
